goog.provide('el8.uiwidget.Panel');

goog.require('el8.model.base');
goog.require('el8.template.uiwidget.Panel');
goog.require('el8.uiwidget.Shade');
goog.require('el8.util.base');

/**
 * This manages a screen sliding from the left or right over
 * the rest of the screen. We use it in practice home for
 * the MultiSchedule (multiSchedule.js) and the doc manager
 * (docMgr/main.js).
 */

el8.uiwidget.Panel = function(spec) {

    spec = spec || {};

    this._width = spec.width || $(window).width() - 100;
    this._height = spec.height || $(window).height() - 200;
    this._zIndex = !el8.util.isNone(spec.zIndex) ? spec.zIndex : null;
    this._offsets = spec.offsets || {};
    this._contentFn = spec.contentFn || null;
    this._listenResize = (spec.listenResize !== false); // defaults to true
    this._minimizedOffsets = spec.minimizedOffsets || null;
    this._minimizedShade = new el8.uiwidget.Shade();
    this._maximizedShade = new el8.uiwidget.Shade();
    this._title = spec.title || '';
    this._slideFromDir = spec.slideFromDir || 'left'; // should be 'right' or 'left'

    this._minimizeFn = spec.minimizeFn || null;

    /** Hold state **/
    this._isInit = false;
    this._minimized = false;
};

el8.uiwidget.Panel.addEvents();

el8.uiwidget.Panel.prototype.init = function() {
    if (this._isInit) { return; }
    this._isInit = true;

    this._container = $(el8.template.uiwidget.Panel.container()).hide();
    $(document.body).append(this._container);
    this._contentElt = $('.panel-content', this._container);
    this.setTitle();

    this._bindTriggers();

    if (this._contentFn) {
        this.setContent(this._contentFn());
    }

    this._container.show();
    this._adjustSize();

    var that = this;
    $(window).on('resize',
        _.debounce(function(e) { that._adjustSize(); }, el8.util.consts.RESIZE_RATE));
};

el8.uiwidget.Panel.prototype._adjustSize = function() {

    /* Set width & height **/
    var width = this._width instanceof Function ?
        this._width() : this._width;
    var margin = this._container.outerWidth(true) - this._container.width();

    this._container.outerWidth(width - margin);
    this._container.height(
        (this._height instanceof Function ?
         this._height() : this._height));
    this._contentElt.height(
        (this._height instanceof Function ?
         this._height() : this._height)
        - $('.panel-title', this._container).outerHeight(true)
    );

    if (this._zIndex !== null) {
        this._container.css('z-index', this._zIndex);
    }

    this.trigger('el8_adjustSize');
};

el8.uiwidget.Panel.prototype.setTitle = function(title) {
    $('.panel-title', this._container).text(title || this._title);
};

el8.uiwidget.Panel.prototype.show = function(doAnimate) {
    if (!this._isInit) { this.init(); }
    this.maximize((doAnimate !== true)); // default to noAnimate=true
};

el8.uiwidget.Panel.prototype.maximize = function(noAnimate) {
    if (!this._isInit) { return; }

    /** Hide the Shades **/
    this._maximizedShade.hide();
    this._minimizedShade.hide();

    /* Set vertical offsets */
    if (this._offsets.top !== undefined) {
        this._container.css({   // Don't animate vertically
            'top': (this._offsets.top instanceof Function ?
                 this._offsets.top() : this._offsets.top)
        });
    }

    /* Set horizontal offsets */
    if (this._offsets.horizontal !== undefined) {
        var horizontalSlideDict = {};
        horizontalSlideDict[this._slideFromDir] = (this._offsets.horizontal instanceof Function ?
            this._offsets.horizontal() : this._offsets.horizontal);

        if (noAnimate) {
            this._container.css(horizontalSlideDict);
        } else {
            this._container.animate(horizontalSlideDict);
        }
    }

    this._showMaximizedShade();

    this._minimized = false;
};

el8.uiwidget.Panel.prototype.minimize = function() {
    if (!this._isInit) { return; }
    if (!this._minimizedOffsets) { return; }
    var that = this;

    /** Hide the Shades **/
    this._maximizedShade.hide();
    this._minimizedShade.hide();

    /* Set vertical offsets */
    if (this._minimizedOffsets.top !== undefined) {
        this._container.css({  // Don't animate vertically
            'top': (this._minimizedOffsets.top instanceof Function ?
                this._minimizedOffsets.top() : this._minimizedOffsets.top)
        });
    }

    /* Set horizontal offsets */
    if (this._minimizedOffsets.horizontal !== undefined) {
        var horizontalSlideDict = {};
        horizontalSlideDict[this._slideFromDir] = (this._minimizedOffsets.horizontal instanceof Function ?
                 this._minimizedOffsets.horizontal() : this._minimizedOffsets.horizontal);

        this._container.animate(horizontalSlideDict, function() {
            /** Show the Shade for expanding **/
            that._showMinimizedShade();
        });
    }

    if (this._minimizeFn) { this._minimizeFn(); }

    this._minimized = true;
};

el8.uiwidget.Panel.prototype.getContentElt = function() {
    return this._contentElt;
};

el8.uiwidget.Panel.prototype.getContentHeight = function() {
    return this._contentElt.outerHeight(true);
};

el8.uiwidget.Panel.prototype.setContent = function($contents) {
    this.getContentElt().html($contents);
};

el8.uiwidget.Panel.prototype.getContainer = function() {
    return this._container;
};

el8.uiwidget.Panel.prototype._bindTriggers = function() {
    var that = this;
    this._container.on('click', '.panel-size-trigger',  function(e) {
        that._minimized ? that.maximize() : that.minimize();
    });
};

el8.uiwidget.Panel.prototype._showMinimizedShade = function() {
    var that = this;
    this._minimizedShade.show(this._container, {
        bindEvents: [['click', function(e) { that.maximize(); }]],
        zIndex: (that.zIndex !== null) ? that._zIndex + 1 : null,
        opacity: 0.8
    });
};

el8.uiwidget.Panel.prototype._showMaximizedShade = function() {
    var that = this;
    this._maximizedShade.show($('#refBoard'), {
        bindEvents: [['click', function(e) { that.minimize(); }]],
        zIndex: (that.zIndex !== null) ? that._zIndex - 1 : null,
        opacity: 0.8
    });
};
